window.addEventListener('DOMContentLoaded', () => {
    // Get all tabs that exist
    const tabs = document.getElementsByClassName('tab-list-item');

    Array.prototype.forEach.call(tabs, (tab) => {
        tab.addEventListener('click', addActiveClass);
    });

    function addActiveClass(e) {
        // Remove any active class if there any
        Array.prototype.forEach.call(tabs, (tab) => {
            tab.classList.remove('active');
        });

        // Set the new selected tab to active
        e.currentTarget.classList.add('active');
    }
});